module.exports = __webpack_public_path__ + "static/media/project.101e8173.jpg";